import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCropNutrition } from 'store/getCropNutritionSlice';
import WithSidebar from 'Layout/WithSidebar';
import image from 'images/small-images-inside-text/plants.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import { vegetablesFull } from 'components/ProductItems/mockData';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import { cropNutritionPrograms } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';

const CropNutritionPrograms = () => {
    const dispatch = useDispatch();
    const { fs_title, fs_view_button, fs_title_background } = useSelector(state => state?.cropNutrition?.data?.data) || {};

    useEffect(() => {
        dispatch(fetchCropNutrition());
    }, [dispatch]);
    return (
        <>
            <Banner title={fs_title} image={fs_title_background} buttonText={fs_view_button} />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>agricultural solutions</LabelButton>
                        <GradientText>
                            Learn how to care for your plants, providing them with
                            <img src={image} alt="decor" />
                            <em>proper nutrition for maximum crop yield</em>
                        </GradientText>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={cropNutritionPrograms} />}>
                    <div className="box">
                        <ProductItems data={vegetablesFull} />
                    </div>
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default CropNutritionPrograms;
